export default "__VITE_ASSET__3qo8rwTc__"